import { render, staticRenderFns } from "./TraceRedirect.vue?vue&type=template&id=24ee39a1&scoped=true&"
import script from "./TraceRedirect.vue?vue&type=script&lang=js&"
export * from "./TraceRedirect.vue?vue&type=script&lang=js&"
import style0 from "./TraceRedirect.vue?vue&type=style&index=0&id=24ee39a1&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24ee39a1",
  null
  
)

export default component.exports